<template>
    <div class="container">
        <v-header :categoryList="categoryList"></v-header>
        <v-banner></v-banner>
        <div class="programa" v-if="categoryList.length">
            <img class="img" :src="item.extra" alt="" v-for="item in categoryList" :key="item.id" @click="goPage(item)">
        </div>
        <div class="about">
         <h2>易小淘宣传片</h2>
         <VideoPlay :src="videoSrc" :posterSrc="posterSrc"></VideoPlay>
        </div> 
         <div class="new" v-if="newVideo && Object.keys(newVideo).length > 0">
        <div class="header"><h3>最新视频</h3>
         <router-link class="more" to="/videoList">查看更多</router-link>
        </div>
        <div class="box">
            <VideoPlay :src="newVideo.spUrl" :posterSrc="newVideo.imageInputs"></VideoPlay>
        </div>
        <div class="line2">{{newVideo.title}}</div>
    </div>
     <div class="new" v-if="newArticle && Object.keys(newArticle).length > 0">
        <div class="header"><h3>最新文章</h3><router-link class="more" :to="{path:newArticle.pidUrl,query:{id:newArticle.pid,pic:newArticle.pidExtra}}">查看更多</router-link></div>
        <img :src="newArticle.imageInputs" alt="">
        <div class="line2" @click="goDetail(newArticle.id)">{{newArticle.shareTitle}}</div>
    </div>  
     <div class="logo">
        <img src="../assets/home_logo.png" alt="">
        <div class="title">易小淘(深圳)物联网科技有限公司</div>
        <div class="beian"><a target="_bank" href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备2021105492号</a></div>
     </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
import VideoPlay from '@/components/videoPlay.vue'
export default {
    components:{VideoPlay},
    data(){
        return{
            categoryList:[],
            newVideo:{},
            videoSrc:require('../assets/video.mp4'),
            posterSrc:require('../assets/e51266e303a7fbbb6eedaa15b955b3e.png'),
            data:'',
            newsList:[],
            loading:false,
            page:-1,
            scrollTop:'',
            clientHeight:'',
            scrollHeight:'',
            newArticle:{},
            isactive:true
    }
            
    },
    created(){
        this.getCategoryList()
        this.getVideo()
        this.getArticle()
    },
    methods:{
        goDetail(id){
            this.$router.push({
                path: '/detail',
                query: {
                    id:id
                }
            })
        },
        getVideo(){
        this.http.get('/api/front/article/spList/3?page=1&limit=1').then((res)=>{
                if(res.data.data.list){
                  this.newVideo = res.data.data.list[0]
                }
            })
        },
        getArticle(){
           this.http.get(`/api/front/article/hot/gwList/2`).then((res)=>{    
                if(res.data.data.list){
                    this.newArticle = res.data.data.list[0]
                }
          })
        },
        changeVideoStatus() {
            const video = this.$refs.videoRef;
            if(video.paused) {
                video.play();
            } else {
                video.pause();
            }
        },
        goPage(item){
           this.$router.push({
                path: item.url,
                query: {
                  id:item.id,
                  pic:item.extra
                }
            })
        },
        getCategoryList(){
            this.http.get('/api/front/article/category/gwList').then((res)=>{
                this.categoryList = res.data.data.list       
            
            })
        }
    },

}
</script>

<style scoped lang="less" >
.container{
     padding-bottom: 1.2rem;
.programa{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0.24rem 0.2rem 0 0.2rem;
    background: #fff; 
    margin-top: 0.2rem;
    .img{
        width: 3.47rem;
        height: 1.46rem;
        margin-bottom: 0.2rem;
    }
    .programa-item{
    width: calc(50% - 0.08rem);
    margin-bottom: .16rem;
    background: rgba(236,106,61,0.7);
    background-size: 100% 100%;

    .programa-br{
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        border: 1px solid #fff;
        padding: 0.3rem 0;
        img{
            width: .3rem;
            height: .3rem;
            display: block;
            margin-bottom: 0.1rem;
        }
        .programa-text{
            font-size: 0.24rem;
            font-weight: bold;
            color: #fff;
        }
    }

    }

    }
     .about{
      padding: 0.48rem 0.2rem 0.2rem 0.2rem;
      background-color: #fff;
      margin-top: 0.2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      h2{
        font-size: 0.4rem;
        color: #333;
        text-align: center;
        margin-bottom: 0.4rem;
        font-family: PingFang SC-Medium, PingFang SC;
      }
    }
    .new{
       padding: 0.27rem 0.2rem 0.24rem 0.2rem;
       background: #fff;
       margin-top: 0.2rem;
       margin-bottom: 0.2rem;
      .header{
         display: flex;
         justify-content: space-between;
         margin-bottom: 0.33rem;
        
         h3{
           font-size: 0.32rem;
           color: #333;
         }
         .more{
           font-size: 0.24rem;
           color: #666;
         }
      }
       .box{
            display: flex;
            justify-content: center;
            margin-bottom: 0.24rem;
         }
      img{
        width: 100%;
        height: 3.34rem;
        margin-bottom: 0.24rem;
      }
    }
    .logo{
       display: flex;
       flex-direction: column;
       align-items: center;
       margin-top: 0.8rem;
       img{
          width: 0.96rem;
          height: 0.96rem;
          margin-bottom: 0.2rem;
       }
       .title{
        color: #666666;
        font-size: 0.24rem;
       }
       .beian{
        font-size: 0.24rem;
        margin-top: 0.05rem;
        color: #666;
        a{
            color: #666;
        }
       }
    }

.line2{
    overflow: hidden;
    text-overflow: ellipsis; // text-overflow css3的属性，当文本溢出时，显示省略号
    display: -webkit-box;
    -webkit-line-clamp: 2; // 设置两行文字溢出
    -webkit-box-orient: vertical;
    overflow:hidden;
    text-overflow:ellipsis;
    font-size: 0.28rem;
    color: #333;
    }
}
</style>




// WEBPACK FOOTER //
// src/modules/home.vue